/**
 * Очистка номера телефона от кода страны
 * @param { string } phone номер телефона
 * @param { number } phoneCode код страны (7 - Россия, 375 - Беларусь, 996 - Кыргызстан)
 */
export const sanitizePhoneInput = (
  phone: string,
  phoneCode: number,
): string => {
  if (phone.startsWith(`+${phoneCode}`)) {
    phone = phone.replace(`+${phoneCode}`, '')
  }

  if (phoneCode === 7 && phone.startsWith('8')) {
    phone = phone.replace('8', '')
  }

  return phone
}
